import { useEffect, useState } from "react";
import logo from "../Assets/deal.png"
import { Link, Outlet, useNavigate } from "react-router-dom"
import Footer from "./Footer";
import { useUser } from "../Context";
import { signOut } from "firebase/auth";
import { toast } from "react-toastify";
import { auth } from "../Firebase";
import Loading from "./Loading";

export default function Header() {
    const navigate = useNavigate();
    async function handleSignOut() {
        try {
            await signOut(auth)
            toast.success("Signed out.")
            navigate('/');
        } catch (error) {
            toast.error("Error in signing out.")
        }
    }
    const { user, loading } = useUser();
    return (
        <>
            <header className="z-50 sticky top-0 left-0 px-12 flex items-center justify-between w-screen h-[12vh] shadow-md bg-white">
                <Link to='/' className="h-full flex gap-4 items-center">
                    <img className="h-12" src={logo} alt="Deal Logo" />
                    <h1 className="text-[2.4rem] antialiased font-semibold text-transparent bg-gradient-to-tr from-sky-500 to-indigo-500 bg-clip-text">LeaseSync {user && "| "+ user.companyName}</h1>
                    {/* <h1 class="text-[2.4rem] antialiased font-semibold text-transparent bg-gradient-to-tr from-sky-500 to-indigo-500 bg-clip-text">Leasync</h1> */}
                </Link>
                <div className="w-1/3">
                    {user &&
                        <div className="flex w-full gap-4 items-center justify-end text-lg text-gray-600">
                            <Link  className="hover:shadow-gray-300 rounded py-1 px-4 hover:shadow-lg hover:bg-sky-500 transition-all duration-200 hover:text-white" to={user.admin?'/admin-dashboard':`/dashboard`}>Dashboard</Link>
                            <Link  className="hover:shadow-gray-300 rounded py-1 px-4 hover:shadow-lg hover:bg-sky-500 transition-all duration-200 hover:text-white" to="/reports">Reports</Link>
                            {/* <Link  className="hover:shadow-gray-300 rounded py-1 px-4 hover:shadow-lg hover:bg-sky-500 transition-all duration-200 hover:text-white" to='/dashboard'>Dashboard</Link> */}
                            <button className="hover:shadow-gray-300 rounded py-1 px-4 hover:shadow-lg hover:bg-red-500 transition-all duration-200 hover:text-white" onClick={() => { handleSignOut() }} >Sign Out</button>
                        </div>
                    }
                    {/* {console.log(loading)} */}
                    {(!user && !loading) && <div className="w-full gap-5 flex  justify-end text-lg text-gray-600 items-center">
                        <Link className="hover:shadow-gray-300 rounded py-1 px-4 hover:shadow-lg hover:bg-sky-500 transition-all duration-200 hover:text-white" to='/sign-in'>
                            Sign In
                        </Link>
                        <Link className="hover:shadow-gray-300 rounded py-1 px-4 hover:shadow-lg hover:bg-sky-500 transition-all duration-200 hover:text-white" to="/sign-up">
                            Sign Up
                        </Link>
                        <Link className="px-4 py-1.5 transition-all duration-200 bg-gradient-to-r from-indigo-500 to-sky-500 text-white shadow-gray-400 rounded-sm hover:shadow-lg shadow-none" to="/get-in-touch">
                            Get in touch
                        </Link>
                    </div>
                    }
                </div>
            </header>
            <Outlet />
            <Footer/>
        </>
    )
}